export default "__VITE_ASSET__Bek9NYQ0__"